import { useEffect, useState } from 'react';
import useRouter from '../hooks/useRouter';
import RouterPrompt from './RouterPrompt';

const useDetectBackButton = (isDirty: boolean) => {
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [confirmLeave, setConfirmLeave] = useState<boolean>(false);
  const { navigate } = useRouter();

  useEffect(() => {
    const handlePopState = () => {
      if (isDirty && !confirmLeave) {
        setModalVisible(true);
        window.history.pushState(null, '', window.location.href);
      } else {
        navigate(-1);
      }
    };

    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [isDirty, confirmLeave, navigate]);

  const handleConfirmLeave = () => {
    setModalVisible(false);
    setConfirmLeave(true);
    setTimeout(() => navigate(-1), 0);
  };

  const handleCancel = () => {
    setModalVisible(false);
  };

  return (
    <RouterPrompt
      isPrompt={modalVisible}
      handleOK={handleConfirmLeave}
      handleCancel={handleCancel}
    />
  );
};

export default useDetectBackButton;
